import Auth from "./Auth/Reducer";
import General from "./General/Reducer";

export default {
    Auth,
    General
}